export const INITIALIZE_SYSTEM_DETAILS = 'INITIALIZE_SYSTEM_DETAILS';
export type INITIALIZE_SYSTEM_DETAILS = typeof INITIALIZE_SYSTEM_DETAILS;

export const INITIALIZE_SYSTEM_DETAILS_SUCCESS =
  'INITIALIZE_SYSTEM_DETAILS_SUCCESS';
export type INITIALIZE_SYSTEM_DETAILS_SUCCESS = typeof INITIALIZE_SYSTEM_DETAILS_SUCCESS;

export const INITIALIZE_SYSTEM_DETAILS_FAILED =
  'INITIALIZE_SYSTEM_DETAILS_FAILED';
export type INITIALIZE_SYSTEM_DETAILS_FAILED = typeof INITIALIZE_SYSTEM_DETAILS_FAILED;
